module.exports = __webpack_public_path__ + "static/media/rsm-cta.bb8f91a0.svg";